export const global = {
    token: '',
    brl: [],
    bk: {
        "REACT_APP_EIPNODEAPI": import.meta.env.VITE_EIPNODEAPI || '',
        "REACT_APP_VERSAO": import.meta.env.VITE_VERSAO || '',
        "REACT_APP_EVIUGUIDURL": import.meta.env.VITE_EVIUGUIDURL || '',
        "REACT_APP_EVIUGU": import.meta.env.VITE_EVIUGU || '',
        "REACT_APP_EVIUGUID": import.meta.env.VITE_EVIUGUID || '',
        "REACT_APP_CHAT": import.meta.env.VITE_CHAT || '',
        "REACT_APP_EVIUGUCX": import.meta.env.VITE_EVIUGUCX || '',
        "REACT_APP_FOTO": import.meta.env.VITE_FOTO || '',
        "REACT_APP_FACE": import.meta.env.VITE_FACE || '',
        "REACT_APP_EVIPLIVE1ini": import.meta.env.VITE_EVIPLIVE1ini || '',
        "REACT_APP_EVIPLIVE1fim": import.meta.env.VITE_EVIPLIVE1fim || '',
        "REACT_APP_LISTAID": import.meta.env.VITE_LISTAID || '',
        "REACT_APP_EVIPPLAY1ini": import.meta.env.VITE_EVIPPLAY1ini || '',
        "REACT_APP_EVIPPLAY2ini": import.meta.env.VITE_EVIPPLAY2ini || ''
    }
}
 